// extracted by mini-css-extract-plugin
export default {"container":"Verbatim_container__PeLFM","Verbatim":"Verbatim_Verbatim__w-CaK","Title":"Verbatim_Title__QOgSw","Text":"Verbatim_Text__GDaSN"};